import {
  Flex,
  RemoteImage,
  Typography,
  IconChevronRight,
  Colors,
} from '@banhala/ui-kit';
import type { PrimaryCardModel, IScreensLogging } from '../../../../api/types';
import { bridge, isNotNil } from '../../../../utils';

type PrimaryCardProps = {
  item: PrimaryCardModel;
  logging: IScreensLogging;
  width: number;
};

export const PrimaryCard = ({ item, logging, width }: PrimaryCardProps) => {
  const hasContent = isNotNil(item.content);

  const handlePress = () => {
    bridge.logAnalyticsEvent({
      name: 'CLICK_PRIMARY_CARD',
      analytics: logging.analytics,
      ably_only_log: logging.ably_only_log,
    });
    if (item.link) {
      bridge.openDeeplink(item.link);
    }
  };

  return (
    <Flex
      onPress={handlePress}
      disabled={!item.link}
      padding={{ bottom: 20 }}
      alignItems="center"
      animatedStyle={(pressed) => ({
        backgroundColor: pressed.interpolate({
          inputRange: [0, 1],
          outputRange: [Colors.bg_always_white, Colors.bg_pressed_primary],
        }),
      })}
    >
      <RemoteImage
        uri={item.image.url}
        width={width}
        height={width * item.image.ratio}
      />

      <Flex margin={{ top: 8 }}>
        <Typography
          type={hasContent ? 'subtitle4' : 'subtitle2'}
          color={hasContent ? 'content_secondary' : 'content_primary'}
          textAlign="center"
        >
          {item.title}
        </Typography>
      </Flex>

      {hasContent && (
        <Typography
          type="body4"
          color="content_secondary"
          textAlign="center"
        >
          {item.content}
        </Typography>
      )}

      {isNotNil(item.button) && (
        <Flex.Row
          alignItems="center"
          gap={2}
          margin={{ top: 8 }}
          padding={{ top: 6, bottom: 6, left: 12, right: 8 }}
          borderRadius={50}
          backgroundColor="bg_secondary"
        >
          <Typography type="subtitle5" color="content_primary">
            {item.button}
          </Typography>
          <IconChevronRight size={12} fill={Colors.content_primary} />
        </Flex.Row>
      )}
    </Flex>
  );
};
